// import moment from 'moment';

export default {
  // 字典结构过滤器
  formatDictionary: function (value, list) {
    if (!value || !list) {
      return '';
    }
    const item = list.find(t => `${t.value}` === `${value}`) || {};
    return item.name;
  },
  // 格式化价格
  formatPrice: function (price) {
    return `${price}元`;
  },
  // 格式化时间
  formatDate: function (str, rule) {
    return str && this.$momentLocal(str, rule || 'YYYY-MM-DD');
  },
  // 格式化为数字
  formatInt: function (str) {
    return Number.parseInt(str, 10);
  },
  // 格式化false为空字符串
  formatEmpty: function (value) {
    return value || '';
  },
  // 格式化浮点数（保留小数点后几位）
  formatNumberCalc: function (value, digit = 2) {
    return Math.round(Number.parseFloat(`${value}`) * 10 ** digit) / 10 ** digit;
  },
  // 格式化数字-千分位
  formatThousandth(num) {
    // 如果输入为空或 undefined，直接返回 num
    if (num === null || num === undefined) {
      return num;
    }
    // 将数字拆分为整数部分和小数部分
    const [integerPart, decimalPart] = num.toString().split('.');
    // 使用正则表达式为整数部分添加千位分隔符
    const re = /(\d)(?=(\d{3})+(?!\d))/g;
    const formattedIntegerPart = integerPart.replace(re, '$1,');
    // 如果存在小数部分，则将整数部分和小数部分拼接起来返回
    if (decimalPart) {
      return `${formattedIntegerPart}.${decimalPart}`;
    }
    // 如果没有小数部分，直接返回格式化后的整数部分
    return formattedIntegerPart;
  }

};
